<template>
  <div>
    <template
      v-if="
        section.type === ProgramSectionTypes.HappyHour ||
        section.type === ProgramSectionTypes.CoffeeBreak ||
        section.description
      "
    >
      <div class="w-8 ml-4 flex justify-center items-start">
        <template v-if="section.type === ProgramSectionTypes.HappyHour">
          <div>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 7.5V23.75M12 7.5V5C12 4.50555 12.1466 4.0222 12.4213 3.61108C12.696 3.19995 13.0865 2.87952 13.5433 2.6903C14.0001 2.50108 14.5028 2.45157 14.9877 2.54804C15.4727 2.6445 15.9181 2.8826 16.2678 3.23223C16.6174 3.58187 16.8555 4.02732 16.952 4.51228C17.0484 4.99723 16.9989 5.49989 16.8097 5.95671C16.6205 6.41353 16.3 6.80397 15.8889 7.07868C15.4778 7.35338 14.9945 7.5 14.5 7.5H12ZM12 7.5V4.375C12 3.75693 11.8167 3.15275 11.4733 2.63884C11.13 2.12494 10.6419 1.7244 10.0709 1.48788C9.49987 1.25135 8.87153 1.18947 8.26534 1.31005C7.65915 1.43063 7.10233 1.72825 6.66529 2.16529C6.22825 2.60233 5.93062 3.15915 5.81005 3.76534C5.68947 4.37153 5.75135 4.99987 5.98788 5.57089C6.2244 6.14191 6.62494 6.62996 7.13884 6.97334C7.65275 7.31672 8.25693 7.5 8.875 7.5H12ZM3.25 12.5H20.75M3.25 12.5C2.58696 12.5 1.95107 12.2366 1.48223 11.7678C1.01339 11.2989 0.75 10.663 0.75 10C0.75 9.33696 1.01339 8.70108 1.48223 8.23223C1.95107 7.76339 2.58696 7.5 3.25 7.5H20.75C21.413 7.5 22.0489 7.76339 22.5178 8.23223C22.9866 8.70108 23.25 9.33696 23.25 10C23.25 10.663 22.9866 11.2989 22.5178 11.7678C22.0489 12.2366 21.413 12.5 20.75 12.5M3.25 12.5V21.25C3.25 21.913 3.51339 22.5489 3.98223 23.0178C4.45107 23.4866 5.08696 23.75 5.75 23.75H18.25C18.913 23.75 19.5489 23.4866 20.0178 23.0178C20.4866 22.5489 20.75 21.913 20.75 21.25V12.5"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </template>
        <template v-else-if="section.type === ProgramSectionTypes.CoffeeBreak">
          <div>
            <svg
              width="30"
              height="31"
              viewBox="0 0 30 31"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M21.25 13H22.25C23.3109 13 24.3283 13.4609 25.0784 14.2814C25.8286 15.1019 26.25 16.2147 26.25 17.375C26.25 18.5353 25.8286 19.6481 25.0784 20.4686C24.3283 21.2891 23.3109 21.75 22.25 21.75H21.25"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M3.75 13H21.25V22.5192C21.25 23.6413 20.7891 24.7174 19.9686 25.5108C19.1481 26.3043 18.0353 26.75 16.875 26.75H8.125C6.96468 26.75 5.85188 26.3043 5.03141 25.5108C4.21094 24.7174 3.75 23.6413 3.75 22.5192V13Z"
                stroke="black"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.5 4.25V8"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M12.5 4.25V8"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M17.5 4.25V8"
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </div>
        </template>
        <template v-else-if="section.description">
          <button class="hover:opacity-70" @click="emit('toggle-description')">
            <BaseIcon
              name="outline_chevron_down"
              class="transform transition duration-100 ease-in-out"
              :class="isDescriptionOpen && 'rotate-180'"
              size="lg"
            />
          </button>
        </template>
      </div>
    </template>
  </div>
</template>

<script setup lang="ts">
import { ProgramSectionTypes } from '~/models/program'
import type { ProgramSection } from '~/models/program'

interface PropsInterface {
  section: ProgramSection
  isDescriptionOpen: boolean
}

withDefaults(defineProps<PropsInterface>(), {
  isDescriptionOpen: false,
})

const emit = defineEmits(['toggle-description'])
</script>
